import { useQuery } from 'react-query';

import { QueryEntity } from '../../types';
import { UserWithMetadata } from '../../types/backend-dto-types';
import useGetFetchConfig from '../../useGetFetchConfig';
import { APIBaseChronos } from '@/api/hosts';

export interface PaginatedResponse<T> {
  data: T[];
  pageCount: number;
  totalCount: number;
}

interface UseFetchOrgUsersPaginatedOptions {
  orgIds?: string[];
  includeMetadata?: boolean;
  page?: number;
  pageSize?: number;
  searchQuery?: string;
}

const useFetchOrgUsersPaginated = (options: UseFetchOrgUsersPaginatedOptions = {}) => {
  const { orgIds = [], includeMetadata = false, page = 1, pageSize = 50, searchQuery } = options;

  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<PaginatedResponse<UserWithMetadata>>(
    [QueryEntity.UsersPaginated, orgIds, includeMetadata, page, pageSize, searchQuery],
    async () => {
      const params = new URLSearchParams({
        orgIds: orgIds.join(','),
        ...(includeMetadata && { includeMetadata: 'true' }),
        page: String(page),
        pageSize: String(pageSize),
        ...(searchQuery && { searchQuery: searchQuery.trim() }),
      });
      const queryParams = params.toString();

      try {
        const res = await fetch(`${APIBaseChronos}/api/org/users/paginated?${queryParams}`, fetchConfigGET);
        return await res.json();
      } catch (err) {
        throw err;
      }
    },
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true, // Keep previous data while fetching new page
    },
  );
};

export default useFetchOrgUsersPaginated;
